module.exports = __webpack_public_path__ + "static/media/placeholder.d511e95c.png";